import React, { Component, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { openPopup, closePopup } from "../../action";
import "./style.scss";
import {
  verifyECartOTP,
  resendOTP,
  encryptAESforKYC,
  encryptAES,
  decryptAES,
} from "../../Authentication/action";
import Dropdown from "../../../dropdown";
import { useState } from "react";
import Authentication from "../../Authentication";
import { round } from "lodash";
import { MODALS } from "../../constants";
import cookie from "react-cookies";
import { getECartTrendingFundData, saveKycDataEcart } from "../action";
import { updateEcartDetails } from "../../../../../actions";
import { NUM_TO_WORD } from "../constants";
import { digitToRupeeNotation } from "../../../../../../utils/common";
import { cleanAuthContent } from "../../Authentication/action";
import moment from "moment";
import { toast } from "react-toastify";

const Ecart = (props) => {
  const {
    eCart,
    closePopup,
    openPopup,
    setCartJourneyPage,
    verifyECartOTP,
    resendOTP,
    onAddToCartClick,
    getECartTrendingFundData,
    saveKycDataEcart,
    cleanAuthContent,
    updateEcartDetails,
  } = props;
  const [fundDetails, setFundDetails] = useState(null);
  const [fundDetailsNew, setFundDetailsNew] = useState([]);
  const [durationValues, setDurationValues] = useState({});
  const [OTP, setOtp] = useState(null);
  const [investmentDetails, setInvestmentDetails] = useState(null);
  const [cartDetails, setCartDetails] = useState([]);
  const [redirectionLink, setRedirectionLink] = useState({});

  useEffect(() => {
    onLoad();
  }, []);

  const onLoad = () => {
    let detailsFromCookies =
      (cookie.load("CartDetails") && cookie.load("CartDetails")) || {};

    setCartDetails(Object.values(detailsFromCookies));
    fetchTrendingFundData();
  };

  const fetchTrendingFundData = async () => {
    let res = getECartTrendingFundData && (await getECartTrendingFundData());
  };

  const getImageSrc = (riskProfile) => {
    var pathName = "null";
    var riskProfile = riskProfile.split(" ").join("").toLowerCase();

    if (riskProfile.includes("moderatelyhigh")) pathName = "moderately-high";
    else if (riskProfile.includes("veryhigh")) pathName = "very-high";
    else if (
      (riskProfile.includes("to") && riskProfile.includes("moderate")) ||
      riskProfile.includes("moderate")
    )
      pathName = "moderate";
    else if (riskProfile.includes("moderatelylow")) pathName = "moderately-low";
    else if (riskProfile.includes("high")) pathName = "high";
    else if (riskProfile.includes("low") && !riskProfile.includes("to"))
      pathName = "low";

    return pathName;
  };
  useEffect(() => {
    if (eCart.eCartTrendingFundData && eCart.eCartTrendingFundData.apiLoaded) {
      setFundDetails(eCart.eCartTrendingFundData?.trending);
    }
  }, [eCart.eCartTrendingFundData]);

  useEffect(() => {
    fundDetails &&
      fundDetails.map((item) => {
        setDurationValues((currentValue) => ({
          ...currentValue,
          [item.fundName]: "1",
        }));
      }); 
      setFundDetailsNew(fundDetails)
  }, [fundDetails]);
  
  useEffect(() => {
    let fundD = [];
    if(cartDetails && fundDetails){
      if(cartDetails.length > 0 && fundDetails.length > 0){
        fundDetails.map((item) => {
          let checkindex = cartDetails.findIndex(cardobj => cardobj.fundName === item.fundName);
          if(checkindex==-1)
          {
            fundD.push(item)
          }
        });
        setFundDetailsNew(fundD)
      }
    }
  }, [cartDetails,fundDetails]);

  const schemeYear = [
    { name: "Since Inception" },
    { name: "5 Years" },
    { name: "3 Years" },
    { name: "1 Year" },
  ];
  const [authvalues, setAuthvalues] = useState({
    pan: "",
    dob: "",
    mobile: "",
    email: "",
  });

  useEffect(() => {
    if (authvalues.pan && authvalues.dob) {
      let object = {
        pan: authvalues.pan,
        dob: moment(authvalues.dob).format("DD-MMM-YYYY"),
        email: authvalues.email,
        mobile: authvalues.mobile,
      };
      setRedirectionLink(encryptAESforKYC(object));
    }
  }, [authvalues]);

    useEffect(() => {
    if (authvalues.pan && authvalues.dob) {
      let object = {
        pan: authvalues.pan,
        dob: moment(authvalues.dob).format("DD-MMM-YYYY"),
        email: authvalues.email,
        mobile: authvalues.mobile,
      };
      setRedirectionLink(encryptAESforKYC(object));
    }
  }, [authvalues]);

  const onSubmit = async (authValues, kycData) => {
    setAuthvalues((currentValue) => ({
      ...currentValue,
      pan: authValues.pan,
      dob: authValues.dob,
      mobile: authValues.mobile,
      email: authValues.email,
    }));
    if (kycData && kycData.data && kycData.data.kycVerifiedFlag) {
      let objectt = {
        pan: authValues.pan,
        dob: moment(authValues.dob).format("DD-MMM-YYYY"),
        email: authValues.email,
        mobile: authValues.mobile,
      };
      let modalData = {
        closeAction: closePopup,
        verifyOtpData: {
          kycData,
          objectt,
        },
        objectt,
        joruneyPage: 6,
        modalClass: "ecart-modal-folio",
      };
      openPopup(MODALS.ECART_MODAL, modalData);
    } else {
      let objectt = encryptAESforKYC({
        pan: authValues.pan,
        dob: moment(authValues.dob).format("DD-MMM-YYYY"),
        email: authValues.email,
        mobile: authValues.mobile,
      });
      await saveKycDataEcart({
        email: authValues.email,
        mobile: authValues.mobile,
        panNumber: authValues.pan,
        kycStatus: "NOT_VERIFIED",
      });
      let modalData = {
        modalClass: "ecart-modal-ekyc",
        joruneyPage: 5,
        objectt,
      };
      openPopup(MODALS.ECART_MODAL, modalData);
    }
  };

  const onOtpSubmit = async (OTP) => {
    closePopup();
    setOtp(OTP);
  };

  const onContinueToPay = () => {
    let childrennriFUnd = true;
    let detailsFromCookies =
      (cookie.load("CartDetails") && cookie.load("CartDetails")) || {};

    if(detailsFromCookies && Object.values(detailsFromCookies) && Object.values(detailsFromCookies).length > 0){
      Object.values(detailsFromCookies).map((item, index) => {
        if(item.cgfApplicable){
          childrennriFUnd = false;
        }
      })
    }
    let modalData = {
      closeAction: cleanAuthContent,
      modalClass: "authentication-modal",
      onSubmit: onSubmit,
      authValues: authvalues,
      childrennriFund: childrennriFUnd
    };
    openPopup(MODALS.AUTHENTICATION, modalData);
    cleanAuthContent();
  };

  const onRemoveFromCart = (investment,index) => {

    setCartDetails((prev) => {
      return prev.filter((fund) => {
        return fund.id != investment.id;
      });
    });

    let cartDetailCookie = cookie.load("CartDetails");
    delete cartDetailCookie[index];

    let itemsObj = {};

    let i = 0;
    for (let index in cartDetailCookie) {
        itemsObj[i] = cartDetailCookie[index];
        i++;
    }
    cartDetailCookie = itemsObj;


    cartDetailCookie &&
      cookie.save("CartDetails", cartDetailCookie, { path: "/" });

    updateEcartDetails(cartDetailCookie);
  };

  const onEditCartDetails = (investment) => {
    onAddToCartClick({ ...investment, isEditFlow: true });
  };

  const onAddFundsClick = () => {
    setCartJourneyPage(2);
  };

  const addTrendingFundToCart = (fund) => {
    onAddToCartClick({
      ...fund,
      isDirect: cartDetails.length > 0 ? cartDetails[0].isDirect : true,
      isRegular: cartDetails.length > 0 ? cartDetails[0].isRegular : false,
    });
  };

  const filterData = fundDetails && fundDetails.filter((fundData) => {
    fundData.fundName != cartDetails.fundName});

  const checkDateDifference = () => {
    let isValid = true;
  
    for (const fund of cartDetails) {
      if (fund.sipOpted && fund.sipDate) {
        const today = new Date();
        const sipDate = new Date(fund.sipDate);
        const timeDifference = sipDate.getTime() - today.getTime();
        const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
  
        if (daysDifference < 17) {
          toast.error("SIP Start Date is not valid. Please choose another date.");
          isValid = false;
          break; // Exit the loop once an invalid date is encountered
        }
      }
    }
    return isValid;
  };

  return (
    <div>
      <div className="popupOuter">
        <div className="popupSec">
          <div className="ecart-screen">
            <div className="ecartscreendiv">
              {/* <img
                src="/images/closeCircle.svg"
                onClick={closePopup}
                className="closeIcons"
              ></img> */}
               <svg width="35" height="35" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={closePopup}>
                <path d="M25.5492 47.6663C37.2593 47.6663 46.8402 37.9163 46.8402 25.9997C46.8402 14.083 37.2593 4.33301 25.5492 4.33301C13.8392 4.33301 4.2583 14.083 4.2583 25.9997C4.2583 37.9163 13.8392 47.6663 25.5492 47.6663Z" fill="#E4E4E4" />
                <path d="M19.5239 32.1315L31.5746 19.8682" stroke="#3A3A3A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M31.5746 32.1315L19.5239 19.8682" stroke="#3A3A3A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <h4
                className="title"
              >
                {cartDetails.length === 0 ? "Add to Cart" : "E-Cart"}
              </h4>
            </div>
            {/* <div className="row">
              <div className="col-1 p-0">
                <img
                  src="/images/closeCircle.svg"
                  onClick={closePopup}
                  className="closeIcons"
                ></img>
              </div>
              <div className="col-11 texttitle p-0">
                <h4 className={cartDetails.length === 0 ? "title me-3" : "title me-4"}>
                  {cartDetails.length === 0 ? "Add to Cart" : "E-Cart"}
                </h4>
              </div>
            </div> */}
            {cartDetails.length > 0 &&
              cartDetails.map((investment, index) => {
                return (
                  <ECartCard
                    investment={investment}
                    key={index}
                    index={index}
                    onEditCartDetails={() => onEditCartDetails(investment)}
                    onRemoveFromCart={() => onRemoveFromCart(investment,index)}
                  />
                );
              })}

            {cartDetails.length < 3 && (
              <div className="transaction1">
                <div className="purchase" onClick={onAddFundsClick}>
                  <div className="addFunds">
                    {/* <img src="/images/addCircle.svg" className="addIcon"></img> */}
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="addIcon">
                      <circle cx="20" cy="20" r="20" fill="#F3F9FF" />
                      <path d="M19.9058 11.4287L19.9058 19.6706L19.9058 27.9122" stroke="#D83731" stroke-width="1.92308" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M28.1499 19.6709L19.908 19.6709L11.6664 19.6709" stroke="#D83731" stroke-width="1.92308" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <h1>Add Funds</h1>
                  </div>
                  <p className="funddescription">
                    You can add maximum three items to the cart
                  </p>
                </div>
              </div>
            )}

            <button
              className={!cartDetails || cartDetails.length === 0 ? "addToCartDisable":"addToCart"}
              onClick={() => {
                if (checkDateDifference()) {
                  onContinueToPay();
                }
              }}
              disabled={!cartDetails || cartDetails.length === 0}
            >
              Continue to pay
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
const ECartCard = (props) => {
  const { onEditCartDetails, onRemoveFromCart, investment, index } = props;
 
  return (
    <>
      <div className="transaction1">
        <div className="header">
          <p>{NUM_TO_WORD[index + 1]} investment</p>
          <div className="edit-remove-button">
            <button onClick={onEditCartDetails}>Edit</button>
            <button onClick={onRemoveFromCart}>Remove</button>
          </div>
        </div>
        <div className="purchase">
          <div className="box1">
            <p className="title">Scheme Name</p>
            <p className="schemeName">{investment.scheme.name}</p>
          </div>
          <div className="box3">
            <div>
              <p className="returntitle">Investment Type</p>
              {investment &&
              investment.sipAmount &&
              investment.purchaseAmount ? (
                <p className="returnpercent">Purchase + SIP</p>
              ) : (
                investment &&
                (investment.sipAmount || investment.purchaseAmount) && (
                  <p className="returnpercent">
                    {investment.sipAmount ? "SIP" : "Purchase"}
                  </p>
                )
              )}
            </div>
            <div>
              <p className="returntitle">Amount</p>
              {investment &&
              investment.sipAmount &&
              investment.purchaseAmount ? (
                <p className="returnpercent">
                  {"₹" +
                    " " +
                    digitToRupeeNotation(
                      parseInt(investment.sipAmount) +
                        parseInt(investment.purchaseAmount)
                    )}
                </p>
              ) : (
                ((investment && investment.sipAmount) ||
                  investment.purchaseAmount) && (
                  <p className="returnpercent">
                    {"₹" +
                      " " +
                      digitToRupeeNotation(
                        parseInt(investment.sipAmount) ||
                          parseInt(investment.purchaseAmount) ||
                          0
                      )}
                  </p>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  eCart: state.eCart,
});
const mapDispatchToProps = (dispatch) => ({
  closePopup: bindActionCreators(closePopup, dispatch),
  openPopup: bindActionCreators(openPopup, dispatch),
  verifyECartOTP: bindActionCreators(verifyECartOTP, dispatch),
  resendOTP: bindActionCreators(resendOTP, dispatch),
  getECartTrendingFundData: bindActionCreators(
    getECartTrendingFundData,
    dispatch
  ),
  saveKycDataEcart: bindActionCreators(saveKycDataEcart, dispatch),
  cleanAuthContent: bindActionCreators(cleanAuthContent, dispatch),
  updateEcartDetails: bindActionCreators(updateEcartDetails, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Ecart);
